import { css } from 'styled-components';
import { CFBaseProgressHelpers, CFBaseProgressTokens } from './styles';
export const CFBaseProgressIndicatorStyles = {
    Item: css `
    margin: 0;
    padding: 0;
    width: ${CFBaseProgressHelpers.itemWidth}px;
    height: ${CFBaseProgressTokens.HEIGHT}px;
    display: flex;
    background-color: ${CFBaseProgressHelpers.itemColor};
    border-radius: ${CFBaseProgressTokens.HEIGHT}px;
  `,
    ItemWithTransition: css `
    width: ${CFBaseProgressHelpers.itemWidth}px;
    background-color: ${CFBaseProgressHelpers.itemColor};
    transition-property: width, background-color;
    transition-duration: ${CFBaseProgressTokens.DURATION}ms;
    transition-timing-function: ease-in-out;
  `,
    Root: css `
    margin: 0;
    padding: 0;
    display: flex;
    flex-flow: row;
    gap: ${CFBaseProgressTokens.GAP}px;
  `,
};
